// Single source of truth for the $497 Bounce City University Blueprint checkout URL.
// Every CTA on the Blueprint sales page reads from BLUEPRINT_CHECKOUT_URL so the
// final Square link only needs to be set once (via env at build time). Until the
// real link is provided we fall back to the on-page pricing anchor so no button
// dead-ends and no analytics event fires against a wrong destination.
export const BLUEPRINT_CHECKOUT_URL =
  process.env.REACT_APP_BLUEPRINT_CHECKOUT_URL || "#pricing";

// The five UTM parameters we want to preserve through checkout. Reads them from
// the current window.location and appends them to the checkout URL so campaign
// attribution survives the hop to Square. Returns the URL unchanged when the
// destination is the local pricing anchor or when no UTMs are present.
export function withUTM(url) {
  if (typeof window === "undefined") return url;
  if (!url || url.startsWith("#")) return url;
  try {
    const src = new URLSearchParams(window.location.search);
    const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
    const params = new URLSearchParams();
    for (const k of keys) {
      const v = src.get(k);
      if (v) params.set(k, v);
    }
    const qs = params.toString();
    if (!qs) return url;
    return url.includes("?") ? `${url}&${qs}` : `${url}?${qs}`;
  } catch {
    return url;
  }
}
